module.exports = {"pagination":{"ListFragments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Fragments"}}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/kinesis-video-archived-media-2017-09-30.paginators.json
// module id = 550
// module chunks = 0